import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsTabs = _resolveComponent("StatisticsTabs")!

  return (_openBlock(), _createBlock(_component_StatisticsTabs, { title: "Количество просмотров" }, {
    "first-tab": _withCtx(() => [
      _renderSlot(_ctx.$slots, "first-tab")
    ]),
    "second-tab": _withCtx(() => [
      _renderSlot(_ctx.$slots, "second-tab")
    ]),
    _: 3
  }))
}